import React, { Component } from "react";
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import hero1 from '../../images/slider/slide-1.jpg';
import hero2 from '../../images/slider/slide-2.jpg';
import hero3 from '../../images/slider/slide-3.jpg';
import hero4 from '../../images/shape/shape.png';

import './style.css';

class Hero extends Component {
    render() {
        var settings = {
            dots: true,
            arrows: true,
            speed: 1200,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            fade: true
        };

        return (
            <section className="hero-slider hero-style-1">
                <Slider {...settings}>
                    {/* Slide 1 */}
                    <div className="slide">
                        <div className="slide-inner" style={{ backgroundImage: `url(${hero1})` }}>
                            <div className="container">
                                <div className="slide-thumb">
                                    <span>Preserving Indian Heritage</span>
                                </div>
                                <div className="slide-title">
                                    <h2>Nardhanamala Centre for Performing <span>Arts Foundation</span></h2>
                                </div>
                                <div data-swiper-parallax="400" className="slide-text">
                                    <p>Nardhanamala Foundation nurtures young minds between 5–10 years with the beauty of Indian performing arts — building confidence, posture, and cultural pride through every step and rhythm.</p>
                                </div>
                                <div className="slide-btns">
                                    <Link to="/programs" className="theme-btn">Join Our Programs <i className="fa fa-angle-double-right" aria-hidden="true"></i></Link>
                                </div>
                            </div>
                            <div className="slide-shape">
                                <img src={hero4} alt="" />
                            </div>
                        </div>
                    </div>

                    {/* Slide 2 */}
                    <div className="slide">
                        <div className="slide-inner" style={{ backgroundImage: `url(${hero2})` }}>
                            <div className="container">
                                <div className="slide-thumb">
                                    <span>Joy Through Movement</span>
                                </div>
                                <div className="slide-title">
                                    <h2>Nardhanamala Centre for Performing <span>Arts Foundation</span></h2>
                                </div>
                                <div data-swiper-parallax="400" className="slide-text">
                                    <p>Our “Dance for Joy” initiative helps women rediscover rhythm, health, and happiness through graceful Indian movements designed for body positivity and self-expression.</p>
                                </div>
                                <div className="slide-btns">
                                    <Link to="/join" className="theme-btn">Join the Movement <i className="fa fa-angle-double-right" aria-hidden="true"></i></Link>
                                </div>
                            </div>
                            <div className="slide-shape">
                                <img src={hero4} alt="" />
                            </div>
                        </div>
                    </div>

                    {/* Slide 3 */}
                    <div className="slide">
                        <div className="slide-inner" style={{ backgroundImage: `url(${hero3})` }}>
                            <div className="container">
                                <div className="slide-thumb">
                                    <span>Art for All</span>
                                </div>
                                <div className="slide-title">
                                    <h2>Nardhanamala Centre for Performing <span>Arts Foundation</span></h2>
                                </div>
                                <div data-swiper-parallax="400" className="slide-text">
                                    <p>We believe every child deserves access to the joy of music and dance. Nardhanamala Foundation conducts free workshops and classes to support underprivileged and tribal communities across India.</p>
                                </div>
                                <div className="slide-btns">
                                    <Link to="/get-involved" className="theme-btn">Support Our Mission <i className="fa fa-angle-double-right" aria-hidden="true"></i></Link>
                                </div>
                            </div>
                            <div className="slide-shape">
                                <img src={hero4} alt="" />
                            </div>
                        </div>
                    </div>
                </Slider>
            </section>
        );
    }
}

export default Hero;
